module.exports = __webpack_public_path__ + "img/sleepless.bef0796c.png";